import React, { useEffect, useLayoutEffect } from "react";
import { BrowserRouter, Route, Routes, Outlet } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";

/// For Page's Links

import ScrollToTop from "./components/partial/ScrollToTop";

import NotFound from "./components/pages/NotFound";

import ProtectedRoute from "./routes/ProtectedRoute";
import PublicRoute from "./routes/PublicRoute";

import SignUp from "./components/auth/SignUp";
import SignIn from "./components/auth/SignIn";
import ForgotPassword from "./components/auth/ForgotPassword";
import ResetPassword from "./components/auth/ResetPassword";
import Thankyou from "./components/auth/Thankyou";
import VerifyYourEmail from "./components/auth/VerifyYourEmail";
import ContactUs from "./components/auth/ContactUs";
import ThankyouResetPassword from "./components/auth/ThankyouResetPassword";

import UploadExistingData from "./components/pages/userJourney/UploadExistingData";
import UploadingExistingDatas from "./components/pages/userJourney/UploadingExistingDatas";

import TermAndCondition from "./components/layout/TermAndCondition";
import Sidebar from "./components/layout/Sidebar";

import GenerateAccessKeyAPI from "./components/pages/apiPlayground/apiPages/GenerateAccessKeyAPI";
import CustomerRegAPI from "./components/pages/apiPlayground/apiPages/CustomerRegAPI";
import TransactionAPI from "./components/pages/apiPlayground/apiPages/TransactionAPI";
import RedemptionAPI from "./components/pages/apiPlayground/apiPages/RedemptionAPI";

import NewLoyaltyCampaign from "./components/pages/campaigns/create/NewLoyaltyCampaign";
import EditLoyaltyCampaign from "./components/pages/campaigns/edit/EditLoyaltyCampaign";
import CampaignList from "./components/pages/campaigns/common/CampaignList";

import CustomerView from "./components/pages/customersList/CustomerView";
import CustomerViewWithUserType from "./components/pages/customersList/CustomerViewWithUserType";
import CustomersList from "./components/pages/customersList/CustomersList";

import Dashboard from "./components/pages/dashboard/Dashboard";

import Invoice from "./components/pages/invoice/Invoice";

import KYC from "./components/pages/kyc/KYC";

import ProductManagement from "./components/pages/product/ProductManagement";

import QRCodeTemplate from "./components/pages/qr/QRCodeTemplate";
import QRCode from "./components/pages/qr/QRCode";
import QRCodeList from "./components/pages/qr/QRCodeList";
import QRCodeSupron from "./components/pages/qr/QRCodeSupron";
import Logs from "./components/pages/qr/Logs/Logs";

import Receipt from "./components/pages/receipt/Receipt";
import CustomerOrder from "./components/pages/receipt/CustomerOrder";

import RedemptionList from "./components/pages/redemption/RedemptionList";

import SchemaSetting from "./components/pages/schema/SchemaSetting";
import TransactionSchema from "./components/pages/schema/TransactionSchema";
import CreateSchema from "./components/pages/schema/CreateSchema";
import CreateTransactionSchema from "./components/pages/schema/CreateTransactionSchema";

import Support from "./components/pages/support/Support";

import ArjunOilTransactionList from "./components/pages/transactionsList/ArjunOilTransactionList";
import TransactionsList from "./components/pages/transactionsList/TransactionsList";
import TransactionListWithoutSchema from "./components/pages/transactionsList/TransactionListWithoutSchema";
import StarblazeTransactionList from "./components/pages/transactionsList/StarblazeTransactionList";
import StarblazeRedemptionList from "./components/pages/redemption/StarblazeRedemptionList";

import CreateUser from "./components/pages/user/CreateUser";
import CustomerList from "./components/pages/user/UserList";
import UserDetails from "./components/pages/user/UserDetails";
import UserManagement from "./components/pages/user/UserManagement";

import AllVouchers from "./components/pages/voucher/AllVouchers";

import Setting from "./components/pages/settings/Setting";

import DecryptTool from "./components/pages/decryptTool/DecryptTool";

// ----------------------------------------------------------------------------------------------------------

const App = () => {
  const SidebarLayout = () => (
    <Sidebar>
      <Outlet />
    </Sidebar>
  );

  return (
    <Provider store={store}>
      <BrowserRouter
        future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
      >
        <ScrollToTop>
          <Routes>
            <Route element={<SidebarLayout />}>
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <>
                      Dashbaord
                      <Dashboard />
                    </>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/upload-existing-data"
                element={
                  <ProtectedRoute>
                    <>
                      <>UploadExistingData</>
                      <UploadExistingData />
                    </>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/uploading-existing-datas"
                element={
                  <ProtectedRoute>
                    <>
                      <>UploadingExistingDatas</>
                      <UploadingExistingDatas />
                    </>
                  </ProtectedRoute>
                }
              />

              <Route
                path="/vouchers"
                element={
                  <ProtectedRoute>
                    <>
                      <>AllVouchers</>
                      <AllVouchers />
                    </>
                  </ProtectedRoute>
                }
              />

              <Route
                path="/customers-list"
                element={
                  <ProtectedRoute>
                    <>
                      <p>CustomersList</p>
                      <CustomersList />
                    </>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/customer-view/:id"
                element={
                  <ProtectedRoute>
                    <CustomerView />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/transactions-list"
                element={
                  <ProtectedRoute>
                    <>
                      <>TransactionsList</>
                      <TransactionsList />
                    </>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/transaction-list"
                element={
                  <ProtectedRoute>
                    <>
                      <>TransactionsList</>
                      <ArjunOilTransactionList />
                    </>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/starblaze-trans-list"
                element={
                  <ProtectedRoute>
                    <>
                      <>TransactionsList</>
                      <StarblazeTransactionList />
                    </>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/redemptions-list"
                element={
                  <ProtectedRoute>
                    <StarblazeRedemptionList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/schema-setting"
                element={
                  <ProtectedRoute>
                    <>
                      <>SchemaSetting</>
                      <SchemaSetting />
                    </>
                  </ProtectedRoute>
                }
              />

              <Route
                path="/create-Schema"
                element={
                  <ProtectedRoute>
                    <>
                      <>CreateSchema</>
                      <CreateSchema />
                    </>
                  </ProtectedRoute>
                }
              />

              <Route
                path="/create-Transaction"
                element={
                  <ProtectedRoute>
                    <>
                      <>CreateTransactionSchema</>
                      <CreateTransactionSchema />
                    </>
                  </ProtectedRoute>
                }
              />

              <Route
                path="/transaction-schema"
                element={
                  <ProtectedRoute>
                    <>
                      <>TransactionSchema</>
                      <TransactionSchema />
                    </>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/transactionSchema"
                element={
                  <ProtectedRoute>
                    <>
                      <>CreateTransactionSchema</>
                      <CreateTransactionSchema />
                    </>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/generate-access-key-api"
                element={
                  <ProtectedRoute>
                    <>
                      <>GenerateAccessKeyAPI</>
                      <GenerateAccessKeyAPI />
                    </>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/customer-registration-api"
                element={
                  <ProtectedRoute>
                    <>
                      <>CustomerRegAPI</>
                      <CustomerRegAPI />
                    </>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/transaction-api"
                element={
                  <ProtectedRoute>
                    <>
                      <>TransactionAPI</>
                      <TransactionAPI />
                    </>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/redemption-api"
                element={
                  <ProtectedRoute>
                    <>
                      <>RedemptionAPI</>
                      <RedemptionAPI />
                    </>
                  </ProtectedRoute>
                }
              />

              <Route
                path="/contact-us"
                element={
                  <ProtectedRoute>
                    <ContactUs />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/product-management"
                element={
                  <ProtectedRoute>
                    <>
                      <>ProductManagement</>
                      <ProductManagement />
                    </>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/customers-list"
                element={
                  <ProtectedRoute>
                    <>
                      <p>CustomersList</p>
                      <CustomersList />
                    </>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/user-management"
                element={
                  <ProtectedRoute>
                    <>
                      <>UserManagement</>
                      <UserManagement />
                    </>
                  </ProtectedRoute>
                }
              />

              <Route
                path="/kyc"
                element={
                  <ProtectedRoute>
                    <>
                      <>KYC</>
                      <KYC />
                    </>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/transactions"
                element={
                  <ProtectedRoute>
                    <>
                      <>TransactionsList</>
                      <TransactionListWithoutSchema />
                    </>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/receipt"
                element={
                  <ProtectedRoute>
                    <>
                      <>Receipt</>
                      <Receipt />
                    </>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/orders"
                element={
                  <ProtectedRoute>
                    <>
                      <>Customer Order</>
                      <CustomerOrder />
                    </>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/user-view/:id"
                element={
                  <ProtectedRoute>
                    <CustomerViewWithUserType />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/user-list"
                element={
                  <ProtectedRoute>
                    <CustomerList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/user-filter"
                element={
                  <ProtectedRoute>
                    <UserDetails />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/qrcode-list"
                element={
                  <ProtectedRoute>
                    <QRCodeList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/support"
                element={
                  <ProtectedRoute>
                    <Support />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/create-user"
                element={
                  <ProtectedRoute>
                    <>
                      <>KYC</>
                      <CreateUser />
                    </>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/my-campaign"
                element={
                  <ProtectedRoute>
                    <>
                      <>LProgram</>
                      <CampaignList />
                    </>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/create-campaign"
                element={
                  <ProtectedRoute>
                    <>
                      <>Lprogram</>
                      <NewLoyaltyCampaign />
                    </>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/my-campaign/edit-campaign/:id"
                element={
                  <ProtectedRoute>
                    <>
                      <>Lprogram</>
                      <EditLoyaltyCampaign />
                    </>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/qrcode-template"
                element={
                  <ProtectedRoute>
                    <>
                      <>QRCodeTemplate</>
                      <QRCodeTemplate />
                    </>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/qr-code"
                element={
                  <ProtectedRoute>
                    <>
                      <>QRCode</>
                      <QRCode />
                    </>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/qr-code-template"
                element={
                  <ProtectedRoute>
                    <>
                      <>QRCode</>
                      <QRCodeSupron />
                    </>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/qr-code-logs"
                element={
                  <ProtectedRoute>
                    <>
                      <>QRCode</>
                      <Logs />
                    </>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/invoice"
                element={
                  <ProtectedRoute>
                    <>
                      <>UploadInvoice</>
                      <Invoice />
                    </>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <ProtectedRoute>
                    <>
                      <>ProfileSettings</>
                      <Setting />
                    </>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/redemption-list"
                element={
                  <ProtectedRoute>
                    <>
                      <>TransactionsList</>
                      <RedemptionList />
                    </>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/decrypt-tool"
                element={
                  <ProtectedRoute>
                    <DecryptTool />
                  </ProtectedRoute>
                }
              />
              <Route
                path="*"
                element={
                  <ProtectedRoute>
                    <NotFound />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/"
              element={
                <PublicRoute>
                  <SignIn />
                </PublicRoute>
              }
            />
            <Route
              path="/signin"
              element={
                <PublicRoute>
                  <SignIn />
                </PublicRoute>
              }
            />
            <Route
              path="/signup"
              element={
                <PublicRoute>
                  <SignUp />
                </PublicRoute>
              }
            />
            <Route
              path="/terms-and-conditions"
              element={
                <PublicRoute>
                  <TermAndCondition />
                </PublicRoute>
              }
            />
            <Route
              path="/forgot-password"
              element={
                <PublicRoute>
                  <ForgotPassword />
                </PublicRoute>
              }
            />
            <Route
              path="/reset-password"
              element={
                <PublicRoute>
                  <ResetPassword />
                </PublicRoute>
              }
            />
            <Route
              path="/thankyou"
              element={
                <PublicRoute>
                  <Thankyou />
                </PublicRoute>
              }
            />

            <Route
              path="/reset-thankyou"
              element={
                <PublicRoute>
                  <ThankyouResetPassword />
                </PublicRoute>
              }
            />
            <Route
              path="/verify-your-email"
              element={
                <PublicRoute>
                  <VerifyYourEmail />
                </PublicRoute>
              }
            />
            <Route
              path="/contactus"
              element={
                <PublicRoute>
                  <ContactUs />
                </PublicRoute>
              }
            />
          </Routes>
        </ScrollToTop>
      </BrowserRouter>
    </Provider>
  );
};

export default App;
